import React from 'react'
import { Route, Switch } from 'react-router'
import { Container } from 'react-bootstrap'
import Blog from './blogPage/blog'
import BlogPost from './blogPost/blogPost'


export default function BlogRouter({ match }) {
    const { path } = match
    return (
        <Container fluid>
            <Switch>
                <Route exact path={path} component={Blog} />
                <Route exact path={`${path}/:id`} component={BlogPost} />
            </Switch>
        </Container>
    )
}
